import React from "react";
import "./DealerInfo.scss";

interface DealerInfoProps {
    logo?: string | null;
    text?: string;
}

const DealerInfo: React.FunctionComponent<DealerInfoProps> = (props) => (
    <div className="DealerInfo">
        <img className="DealerInfo__image" src={props.logo || ""} alt="" /> <br />
        <div>{props.text}</div>
    </div>
);

DealerInfo.defaultProps = {
    logo: "",
    text: "",
};

export default DealerInfo;
